<template>
  <section class="SectionVideo" :class="background">
    <Wrap class="lg">
      <h3 class="title">
        {{ title }}
      </h3>

      <Markdown v-if="content" :markdown="content" />

      <Video v-if="videoSrc" :src="videoSrc" :title="title" />

      <div v-if="cta" class="cta">
        <Route class="Btn" :title="cta" :to="{ name: $route.name, hash: '#FooterContact' }">
          {{ cta }}
        </Route>
      </div>
    </Wrap>
  </section>
</template>

<script>
import Video from 'views/components/Video'
const Markdown = () => import(/* webpackChunkName: 'showdown' */ 'views/components/Markdown')

export default {
  components: { Markdown, Video },
  props: {
    background: String,
    content: String,
    cta: String,
    title: String,
    videoSrc: String,
  },
}
</script>

<style lang="scss">
.SectionVideo {
  .title {
    margin-bottom: 3rem;
  }

  p {
    margin-bottom: 2rem;
    @include md {
      margin-bottom: 3rem;
    }
  }

  .cta {
    margin-top: 3rem;
    text-align: center;
    @include md {
      margin-top: 4rem;
    }
  }
}
</style>
